export const de = {
  locale: 'de',
  nav: {
    setup: 'Kommandozentrale',
    news: 'Nachrichten',
    brand: 'WC26 Simulator',
    teamName: 'Team',
    tactics: 'Taktik',
    fixtures: 'Spielplan',
    standings: 'Tabelle',
    knockout: 'K.o.-Runde',
    teamStats: 'Team-Statistiken',
    playerStats: 'Spieler-Statistiken',
  },
  landing: {
    title: 'WM-Simulation',
    subtitle: 'Vom Eröffnungsspiel bis zum Finale. Wähle deinen Platz als Zuschauer oder übernimm als Trainer das Kommando.',
    audienceMode: {
      title: 'Zuschauermodus',
      subtitle: 'Komplette Turnierübersicht',
      desc: 'Durchlaufe jedes Spiel des Turniers, verfolge Nachrichten, Tabellen, K.o.-Bäume, Team- und Spielerstatistiken.',
    },
    coachMode: {
      title: 'Trainermodus',
      subtitle: 'Übernimm eine Nationalmannschaft',
      desc: 'Wähle eine Nationalmannschaft und setze dich auf die Trainerbank. Passe Formation, Mentalität, Pressing und Angriffsausrichtung an.',
    },
    completed: 'Abgeschlossen',
    upcoming: 'Anstehend',
    championRanking: 'Meistersimulation',
    coachPickRanking: 'Trainerwahlen',
    noCompleted: 'Noch keine abgeschlossenen Spiele.',
    noUpcoming: '',
    noCoachPick: 'Noch keine Trainermodus-Auswahlen aufgezeichnet.',
    coachSetup: {
      title: 'Wähle dein Team und führe es zum Ruhm',
      back: 'Zurück',
      start: 'Starte meine WM-Reise',
      processing: 'Reise wird erstellt',
      hiddenTeamsOpen: "Versteckte Teams öffnen",
      hiddenTeamsClose: "Versteckte Teams schließen",
    },
    rosterInfo: 'Gruppe {group} · {count} Spieler',
    simKicker: {
      audience: 'Zuschauermodus · Volle Berichterstattung',
      coach: 'Trainermodus · Gruppe {group}',
    },
    simTitle: {
      audience: 'WM-Berichterstattungszentrum',
      coach: '{flag} {name}s WM-Reise',
    },
    warning: {
      leave: 'Verlassen führt zum Verlust der Simulationsdaten.',
      confirm: 'Verlassen führt zum Verlust der Simulationsdaten. Bist du sicher?',
    },
    groupLabel: 'Gruppe {id}',
    championCount: '{count} Mal',
    coachPickCount: '{count} Wahlen',
  },
  common: {
    continue: 'Weiter',
    processing: 'Verarbeitung',
    completed: 'Abgeschlossen',
    close: 'Schließen',
    back: 'Zurück',
    vs: 'VS',
    restart: 'Neuer Lauf',
    restartConfirm: 'Einen neuen Lauf starten? Der aktuelle Fortschritt und lokal gespeicherte Daten werden gelöscht.',
    playAgain: 'Noch einmal',
  },
  team: {
    tab: {
      players: 'Spieler',
      fixtures: 'Spielplan',
      tactic: 'Taktik',
    },
    playerTable: {
      player: 'Spieler',
      club: 'Verein',
      status: 'Status',
      position: 'Pos',
      ability: 'Bewertung',
      age: 'Alter',
      caps: 'LS',
      ntGoals: 'NT T',
      apps: 'Eins',
      goals: 'T',
      assists: 'V',
      rating: 'Schnitt',
    },
    status: {
      redCard: 'Rote Karte',
    },
    noTactic: 'Dieses Team hat noch keine Spiele absolviert.',
    tactic: {
      formation: 'Formation',
      mentality: 'Mentalität',
      width: 'Breite',
      tempo: 'Tempo',
      passing: 'Passspiel',
      attackRoute: 'Angriffsfokus',
      transition: 'Umschaltspiel',
      pressing: 'Pressing',
      defensiveLine: 'Abwehrkette',
      possession: 'Ballbesitz',
    },
  },
  tactics: {
    formation: 'Formation',
    more: 'Weitere Formationen',
    roster: {
      title: 'Kader',
      order: '#',
      status: 'Status',
      name: 'Name',
      position: 'Pos',
      ability: 'Bewertung',
      apps: 'Eins',
      goals: 'T',
      assists: 'V',
    },
    emptySlot: 'Frei',
    noData: 'Keine Taktikdaten verfügbar',
    benchPrefix: 'Ers',
    starterPrefix: 'XI',
  },
  stats: {
    team: {
      title: 'Team-Statistiken',
      subtitle: 'Sortiert nach Gesamtleistung',
      noData: 'Keine Teamdaten.',
      ranking: 'Team-Rangliste',
      value: 'Wert',
      matches: 'Spiele',
    },
    player: {
      title: 'Spieler-Statistiken',
      subtitle: 'Spieler-Rangliste',
      noData: 'Keine Spielerdaten.',
      nationality: 'Land',
      value: 'Wert',
      apps: 'Eins',
    },
    playerTotals: {
      title: 'Kader-Gesamtstatistiken',
      subtitle: 'Nur abgeschlossene Spiele.',
      noData: 'Dein Team hat noch kein Spiel absolviert.',
    },
    groups: {
      overall: 'Übersicht',
      form: 'Form',
      discipline: 'Disziplin',
      attack: 'Angriff',
      creative: 'Kreativ',
      goalkeeping: 'Torhüter',
    },
    items: {
      avgPossession: 'Ø Ballbesitz',
      goalsFor: 'Tore für',
      xg: 'xG',
      shots: 'Schüsse',
      formText: 'Form',
      winStreak: 'Siegessträhne',
      unbeatenStreak: 'Ungeschlagen',
      winlessStreak: 'Ohne Sieg',
      scorelessStreak: 'Ohne Tor',
      yellowCards: 'Gelbe Karten',
      redCards: 'Rote Karten',
      fouls: 'Fouls',
      goals: 'Tore',
      assists: 'Vorlagen',
      minutesPerGoal: 'Min/Tor',
      apps: 'Einsätze',
      starts: 'Startelf',
      averageRating: 'Ø Bewertung',
      keyPasses: 'Torschussvorlagen',
      passesAttempted: 'Pässe',
      passCompletion: 'Pass %',
      saves: 'Paraden',
    },
    descriptions: {
      avgPossession: 'Durchschnittlicher Ballbesitz in abgeschlossenen Spielen',
      goalsFor: 'Erzielte Tore gesamt',
      xg: 'xG gesamt',
      shots: 'Schüsse gesamt',
      formText: 'Aktuelle Form',
      winStreak: 'Aktuelle Siegesserie',
      unbeatenStreak: 'Aktuelle Ungeschlagen-Serie',
      winlessStreak: 'Aktuelle Serie ohne Sieg',
      scorelessStreak: 'Spiele in Folge ohne Tor',
      yellowCards: 'Gelbe Karten gesamt',
      redCards: 'Rote Karten gesamt',
      fouls: 'Fouls gesamt',
      playerGoals: 'Torschützenliste',
      playerAssists: 'Vorlagen-Rangliste',
      playerXg: 'Spieler-xG-Rangliste',
      playerShots: 'Schuss-Rangliste',
      minutesPerGoal: 'Minuten pro Tor',
      playerApps: 'Einsatz-Rangliste',
      playerStarts: 'Spiele mit 45+ Minuten',
      playerYellowCards: 'Gelbe Karten Spieler',
      playerRedCards: 'Rote Karten Spieler',
      playerAvgRating: 'Durchschnittsbewertung',
      playerKeyPasses: 'Torschussvorlagen Spieler',
      playerPasses: 'Pässe gesamt',
      playerPassCompletion: 'Passgenauigkeit in Prozent',
      playerSaves: 'Paraden-Rangliste',
    },
  },
  position: {
    gk: 'Torhüter',
    def: 'Verteidiger',
    mid: 'Mittelfeld',
    fwd: 'Stürmer',
  },
  stage: {
    'Group Stage': 'Gruppenphase',
    'Round of 32': '1. Runde',
    'Round of 16': 'Achtelfinale',
    'Quarter-final': 'Viertelfinale',
    'Semi-final': 'Halbfinale',
    'Third Place': 'Spiel um Platz 3',
    'Final': 'Finale',
  },
  match: {
    penaltyMarker: 'E',
    extraTimeMarker: 'V',
    penalty: {
      scored: 'Verwandelt',
      missed: 'Verschossen',
    },
    status: {
      finished: 'Beendet',
      notStarted: 'Nicht begonnen',
      pending: 'Ausstehend',
    },
    viewDetail: 'Details anzeigen',
    modal: {
      teamData: 'Team-Daten',
      playerData: 'Spieler-Daten',
      finalResult: 'Endergebnis',
      restart: 'Noch einmal',
      subtitle: {
        extra: 'RZ {normal}, V {extra}.',
        penalty: 'RZ {normal}, V {extra}, E {penalty}, {winner} weiter.',
      },
    },
    shootout: 'Elfmeterschießen',
    extraTime: 'Verlängerung',
    decision: {
      penalty: ' · E {home}-{away}',
      extra: ' · V {home}-{away}',
    },
    news: {
      penalty: 'Das Spiel endete {normal} nach der regulären Zeit und {extra} nach Verlängerung; {winner} gewann {penalty} im Elfmeterschießen.',
      extraTime: 'Das Spiel endete {normal} nach der regulären Zeit, mit {goals} weiteren Toren in der Verlängerung. Endstand: {final}.',
    },
    fallback: '{home} und {away} beendeten das Spiel {score} in der {stage}.',
    eventsFallback: 'Das Spiel wurde durch Mittelfeldkontrolle und defensive Details entschieden.',
    xg: 'xG {home}/{away}',
    possession: 'Ballbesitz {home}/{away}',
    shots: 'Schüsse {home}/{away}',
    best: 'Bester {player}',
    simulate: 'Simulieren',
    simTitle: 'Simulationsergebnisse',
    simulating: 'Simuliere…',
    simProgress: '10 Simulationen für dieses Spiel',
  },
  fixture: {
    title: 'Spielplan',
    noDate: 'Kein Spieltag',
    prevDay: 'Vorheriger Spieltag',
    nextDay: 'Nächster Spieltag',
  },
  knockout: {
    title: 'K.o.-Runde',
    subtitle: 'Der Weg von der 1. Runde bis zum Finale',
    tabs: {
      bracket: 'Turnierbaum',
    },
    stageNotGenerated: 'Diese Phase wurde noch nicht generiert.',
    tbd: 'N.N.',
  },
  standings: {
    rank: 'Rang',
    team: 'Team',
    played: 'Sp',
    wins: 'S',
    draws: 'U',
    losses: 'N',
    goalsFor: 'T+',
    goalsAgainst: 'T-',
    goalDiff: 'TD',
    points: 'Pkt',
    filter: 'Filter',
  },
  tacticsControls: {
    mentality: {
      label: 'Mentalität',
      options: ['Rundum-Angriff', 'Angreifen', 'Positiv', 'Ausgeglichen', 'Vorsichtig', 'Defensiv', 'Betonschutz'],
    },
    width: {
      label: 'Breite',
      options: ['Eng', 'Relativ Eng', 'Normal', 'Relativ Breit', 'Breit'],
    },
    tempo: {
      label: 'Tempo',
      options: ['Langsam', 'Relativ Langsam', 'Normal', 'Relativ Schnell', 'Schnell'],
    },
    passing: {
      label: 'Passspiel',
      options: ['Lange Bälle', 'Direkt', 'Gemischt', 'Kurz', 'Sehr Kurz'],
    },
    attackRoute: {
      label: 'Angriffsfokus',
      options: ['Außen', 'Gemischt', 'Zentrum'],
    },
    transition: {
      label: 'Umschaltspiel',
      options: ['Herausspielen', 'Aufbau von Hinten', 'Gemischt', 'Schnell ins Mittelfeld', 'Schnell nach Vorne'],
    },
    defensiveLine: {
      label: 'Abwehrkette',
      options: ['Tief', 'Mittel', 'Hoch'],
    },
    pressing: {
      label: 'Pressing',
      options: ['Niedrig', 'Mittel', 'Hoch'],
    },
    possession: {
      label: 'Ballbesitz',
      options: ['Zurückziehen', 'Weniger Ballbesitz', 'Ausgeglichen', 'Mehr Ballbesitz', 'Totale Kontrolle'],
    },
  },
  formations: {
    '4-2-3-1A': '4 Abwehr, 2 DM, 2 Flügel, 1 OM, 1 Stürmer',
    '4-2-3-1S': '4 Abwehr, 2 DM, 1 ZM, 2 Flügel, 1 Stürmer',
    '4-3-3': '4 Abwehr, 3 Mittelfeld, 3 Stürmer',
    '4-1-4-1': '4 Abwehr, 1 DM, flache 4 im Mittelfeld, 1 Stürmer',
    '4-1-2-2-1': '4 Abwehr, 1 DM, 2 ZM, 2 Flügel, 1 Stürmer',
    '4-3-1-2M': '4 Abwehr, 3 ZM, 1 OM, 2 Stürmer',
    '4-3-1-2D': '4 Abwehr, 3 DM, 1 ZM, 2 Stürmer',
    '4-3-2-1M': '4 Abwehr, 3 ZM, 2 OM, 1 Stürmer',
    '4-3-2-1D': '4 Abwehr, 3 DM, 2 ZM, 1 Stürmer',
    '4-3-2-1S': '4 Abwehr, 3 ZM, 2 Flügel, 1 Stürmer',
    '4-4-1-1': '4 Abwehr, flache 4 im Mittelfeld, 1 OM, 1 Stürmer',
    '4-2-2-2': '4 Abwehr, 2 DM, 2 Flügel, 2 Stürmer',
    '4-4-2F': '4 Abwehr, flache 4 im Mittelfeld, 2 Stürmer',
    '4-4-2D': '4 Abwehr, Raute im Mittelfeld, 2 Stürmer',
    '3-3-2-2': '3 IV, 2 Außen, 1 DM, 2 ZM, 2 Stürmer',
    '3-2-4-1': '3 IV, 2 DM, 2 breit, 2 ZM, 1 Stürmer',
    '3-2-2-2-1': '3 IV, 2 Außen, 2 ZM, 2 Flügel, 1 Stürmer',
    '3-2-3-2D': '3 IV, 2 DM, 2 breit, 1 ZM, 2 Stürmer',
    '3-2-3-2W': '3 IV, 2 Außen, 3 ZM, 2 Stürmer',
    '3-4-1-2': '3 IV, 2 Außen, 2 DM, 1 OM, 2 Stürmer',
    '3-4-2-1S': '3 IV, 2 Außen, 2 DM, 2 Flügel, 1 Stürmer',
    '3-4-2-1C': '3 IV, 2 Außen, 2 DM, 2 OM, 1 Stürmer',
    '3-4-3F': '3 IV, flache 4 im Mittelfeld, 3 Stürmer',
    '3-4-3D': '3 IV, Raute im Mittelfeld, 3 Stürmer',
    '5-3-2': '5 Abwehr, 3 ZM, 2 Stürmer',
    '5-4-1F': '5 Abwehr, flache 4 im Mittelfeld, 1 Stürmer',
    '5-4-1D': '5 Abwehr, Raute im Mittelfeld, 1 Stürmer',
    '5-2-2-1': '5 Abwehr, 2 DM, 2 Flügel, 1 Stürmer',
  },
  news: {
    title: 'Nachrichten',
    subtitle: 'Spieltag-Updates',
    titleTexts: {
      groupRecap: 'Gruppenphase-Rückblick: Qualifikanten, Überraschungen und Tabellen',
      knockoutRecap: '{stage}-Rückblick: Qualifikanten und entscheidende Wendepunkte',
      stagePreview: '{stage}-Vorschau: Schlüsselbegegnungen und Prognosen',
      championRoad: '{flag} {name}s Weg zum Ruhm',
      awards: 'WM-Auszeichnungen: Bester Spieler, Torschützenkönig und bester Torhüter',
      review: 'WM-Rückblick: Meister, Überraschungen, Ergebnisse und Helden',
      coachSummary: '{team}s Turnierrückblick',
    },
    kicker: {
      author: 'Nachricht vom Autor',
      guide: 'Kurzanleitung',
      welcome: {
        coach: 'Willkommen an der Seitenlinie',
        audience: 'Willkommen im Zentrum',
      },
      stageRecap: 'Rückblick · {stage}',
      stagePreview: 'Vorschau · {stage}',
      champion: 'Meistergeschichte',
      awards: 'Auszeichnungen',
      tournamentReview: 'Turnierrückblick',
      pregame: 'Vor dem Spiel',
      coachSummary: 'Kampagnenrückblick',
    },
    default: {
      title: 'Simulation noch nicht gestartet',
      body: 'Sobald du einen Modus wählst, beginnen die Nachrichten.',
    },
    guide: {
      title: 'Weiter führt dich zuerst durch Nachrichten, dann zum Spieltag',
      body: 'Der {Weiter}-Button befindet sich oben rechts auf der Seite. Im Zuschauermodus werden ungelesene Nachrichten zuerst angezeigt. Danach siehst du den Spielplan. Klicke erneut auf {Weiter}, um die Spiele des Tages zu simulieren.',
    },
    author: {
      title: 'Ein (großes) Dankeschön vom Autor',
      body: 'Danke, dass du den ästhetischen Geschmack eines programmierenden Nachteulen ertragen hast. Wenn dir die Simulation gefallen hat, lob den Autor; wenn das Ergebnis eine Überraschung war… naja, das ist die Schönheit des Fußballs! Für Feedback erreichst du mich unter x.com/diysimon oder Xiaohongshu (diysimon).',
    },
    finalThanks: {
      title: 'Turnier beendet — Danke fürs Mitspielen!',
      body: 'Die WM 2026 ist zu Ende. Vielen Dank, dass du diese Simulation erlebt hast! Folge dem Autor (X @diysimon / Xiaohongshu diysimon) für Updates, Feedback und zukünftige Projekte. Starte gerne einen neuen Durchlauf und probiere einen anderen Weg!',
    },
    coachSummary: {
      intro: 'Deine Reise mit {team} ist zu Ende. Das Team beendete das Turnier als {position}.',
      record: 'Im Turnierverlauf erzielte {team} {wins} Siege, {draws} Unentschieden, {losses} Niederlagen, mit {goalsFor} erzielten und {goalsAgainst} Gegentoren.',
      position: '{team} belegte den {position}.',
      exit: 'Sie schieden im {stage} gegen {opponent} aus.',
      exitNone: 'Sie beendeten das Turnier ohne Niederlage in der K.o.-Runde.',
      topScorer: 'Torschützenkönig: {name} mit {goals} Tor(en).',
      noScorer: 'Kein Spieler ragte in der Torschützenliste hervor.',
      bestWin: 'Höchster Sieg: {match}.',
      meta: '{wins}S {draws}U {losses}N | {goalsFor}ET {goalsAgainst}GT | {position}',
      factRecord: 'Bilanz: {wins}S {draws}U {losses}N',
      factGoals: 'Tore: {goalsFor} / {goalsAgainst} (Differenz {diff})',
      factTopScorer: 'Torschützenkönig: {name} ({goals} Tore)',
      factChampion: '{team} ist Weltmeister!',
      factFinish: 'Endplatzierung: {position}',
      positions: {
        champion: 'Weltmeister',
        runnerUp: 'Zweiter',
        semiFinal: 'Halbfinalist',
        quarterFinal: 'Viertelfinalist',
        round16: 'Achtelfinale',
        round32: '1. Runde',
        groupStage: 'Gruppenphase',
      },
    },
    welcome: {
      coach: {
        title: '{flag} {name} beginnt die WM-Reise',
        body: 'Du hast die Leitung von {name} übernommen. Nutze das linke Menü für Kader, Taktik, Spielplan und Statistiken.',
      },
      audience: {
        title: 'WM 2026 Gesamtsimulation geladen',
        body: 'Du siehst das Turnier als Zuschauer. Das System schreitet Spiel für Spiel voran.',
      },
    },
    facts: {
      thanks: 'Danke fürs Spielen',
      feedback: 'Feedback willkommen',
      entertainment: 'Simulation nur zu Unterhaltungszwecken',
      newsFirst: 'Neueste Nachrichten zuerst',
      fixtureBrowse: 'Spielplan nach Spieltag',
      resultsGenerate: 'Ergebnisse generieren Nachrichten',
      newsUpdates: 'Nachrichtenaktualisierungen live',
      timeline: 'Zeitleiste zeigt kommende Spiele',
      refreshWarning: 'Aktualisieren oder Verlassen verliert Simulation',
      operation: 'Spielanleitung',
      preMatch: 'Vorbericht',
    },
    narrative: {
      intro: {
        penalty: '{winner} setzte sich nach einem nervenaufreibenden {stage} mit {score} im Elfmeterschießen durch.',
        extraTime: '{winner} gewann {winnerScore} nach Verlängerung und sicherte sich einen hart erkämpften {stage}-Sieg.',
        win: [
          '{winner} kontrollierte das Tempo im {stage} und sicherte einen {score}-Sieg.',
          '{winner} setzte sich mit solider Spielweise in beide Richtungen durch und gewann {score} im {stage}.',
          '{winner} nutzte die Schlüsselmomente in diesem {stage}-Duell und siegte {score}.',
          '{winner} machte im {stage} keine Fehler und fuhr einen {score}-Sieg ein.',
          'Der {stage} war von Beginn an umkämpft, aber {winner}s entscheidendes Tor machte {score}.',
        ],
        draw: [
          'Ein spannender {stage} endete unentschieden, {home} und {away} trennten sich {score}.',
          '{home} und {away} lieferten sich ein Duell im {stage}, aber keiner fand den Siegtreffer — {score} der Endstand.',
          'Der {stage} endete ohne Sieger: {home} und {away} teilten die Punkte bei {score}.',
        ],
      },
      noEvent: [
        'Keine Seite konnte den entscheidenden Durchbruch erzielen. Das Spiel war von Mittelfeldkämpfen und Abwehrblöcken im letzten Drittel geprägt.',
        'Beide Abwehrreihen standen gut und ließen nur wenige echte Torchancen zu.',
        'Der Abschluss prägte das Spiel — vielversprechende Aktionen scheiterten immer wieder im letzten Moment.',
      ],
      goal: {
        extraTime: [
          '{minute}, die Verlängerung erreichte ihre kritische Phase. {scorer} erreichte den Pass von {assister} und {method} zum {score}.',
          '{minute}, {team} nutzte ihre Chance in der Verlängerung, als {scorer} am Torwart vorbei {method}, {team} {state}.',
          '{minute}, mit müden Beinen und sich öffnenden Räumen brachte {scorer} den Ball im Netz unter — {score}.',
          '{minute}, {scorer} sorgte für den entscheidenden Moment in der Verlängerung, {method} und brachte {team} wieder in Führung.',
        ],
        withAssist: [
          '{minute}, {scorer} erreichte {assister}s Flanke von rechts, {method} vor dem Verteidiger zum {score}, {team} {state}.',
          '{minute}, {assister} spielte einen entscheidenden Pass, {scorer} nahm ihn auf und {method} zum Tor, {team} {state}.',
          '{minute}, {team} kombinierte geschickt. {assister} legte auf {scorer} ab, der {method} — {score}.',
          '{minute}, {scorer} profitierte von {assister}s Hereingabe und {method} am chancenlosen Torwart vorbei, {team} {state}.',
          '{minute}, {assister} spielte einen Pass in die Schnittstelle, {scorer} nahm ihn direkt und {method} zum Tor — {score}.',
          '{minute}, {team} eroberte den Ball hoch in der gegnerischen Hälfte. {assister} legte quer auf {scorer}, der {method}.',
          '{minute}, {assister} brachte die Standardsituation in den Strafraum. {scorer} stieg über alle und {method}, {team} {state}.',
          '{minute}, {scorer} erreichte {assister}s Rücklage und {method} direkt — der Angriff führte zum {score}.',
          '{minute}, {assister} zog Verteidiger auf sich, bevor er ablegte. {scorer} fand den Raum und {method}, {team} {state}.',
          '{minute}, {team} ließ den Ball geduldig laufen, bis sich die Lücke öffnete. {assister} spielte den entscheidenden Pass und {scorer} {method} zum Tor.',
        ],
        solo: [
          '{minute}, {scorer} schüttelte einen Verteidiger an der Strafraumgrenze ab und {method}, {team} {state} — {score}.',
          '{minute}, {scorer} erlief eine verunglückte Abwehraktion und {method} ins leere Tor.',
          '{minute}, {scorer} zog vom Mittelfeld bis zur Strafraumgrenze und schoss einen {method} ins Netz.',
          '{minute}, {team}s hohes Pressing sorgte für Chaos. {scorer} reagierte am schnellsten und {method} zum {score}.',
          '{minute}, {scorer} reagierte im Gewühl am schnellsten, {method} aus kurzer Distanz, {team} {state}.',
        ],
        methodHigh: ['köpfte', 'staubte ab', 'lupfte', 'drehte sich aus kurzer Distanz'],
        methodLow: ['Donnerschuss', 'Schlenzer', 'Schuss aus der Ferne', 'Volleyabnahme'],
        methodMid: ['schoss', 'schob ein', 'hämmerte', 'vollendete ruhig', 'schlenzte aus spitzem Winkel'],
      },
      chance: [
        '{minute}, {team} wäre fast {chanceState}. {player} tauchte vor dem Tor auf, aber der Torwart behielt die Oberhand.',
        '{minute}, {player} hatte eine goldene Chance im Strafraum, setzte den Ball aber im letzten Moment daneben.',
        '{minute}, {team} konterte schnell, aber {player}s Abschluss strich knapp am Pfosten vorbei.',
        '{minute}, {player} bekam eine gute Flanke, konnte sie aber nicht aufs Tor bringen.',
      ],
      redCard: [
        '{minute}, {team} erhielt einen schweren Schlag, als {player} die Rote Karte sah — das veränderte die Dynamik des Spiels.',
        '{minute}, {player} flog vom Platz und zwang {team}, sich für den Rest des Spiels neu zu sortieren.',
        '{minute}, der Schiedsrichter zeigte {player} die Rote Karte. {team}s Spielplan musste sofort umgestellt werden.',
      ],
      flow: {
        xgGap: '{dominant} erspielte sich die besseren Chancen, führte {xgHome}-{xgAway} im xG und {shotsHome}-{shotsAway} bei den Schüssen.',
        possession: '{controller} dominierte den Ball mit {possession}% Ballbesitz, aber die Effizienz im Strafraum war entscheidender.',
        balanced: 'Der Qualitätsunterschied bei den Chancen war gering ({xgHome}-{xgAway} xG), das Spiel wurde in den Umschaltmomenten und beim Abschluss entschieden.',
      },
      tactic: {
        control: [
          'Taktisch diktierte {controller} das Tempo, ließ den Ball mit geduldigem Passspiel und {possession}% Ballbesitz laufen.',
          '{controller}s Plan war klar: Ball halten, über die Flügel und Halbräume kommen und {away} daran hindern, Rhythmus zu finden.',
          '{controller} nutzte anhaltenden Ballbesitz, um das Pressing des Gegners zu schwächen und das Spiel nach eigenen Vorstellungen zu gestalten.',
          '{controller} blieb kompakt und geduldig am Ball und verwandelte Ballbesitz in mehr Zeit im letzten Drittel.',
        ],
        direct: [
          '{direct} jagte nicht dem Ballbesitz hinterher — sie priorisierten schnelle Bälle in den Strafraum, und mehr Schüsse spiegelten diesen Ansatz wider.',
          'Im Angriff fand {creator} besser gefährliche Räume, und der Vorteil bei Torschussvorlagen hielt die Abwehr unter Druck.',
          '{direct} bewegte den Ball zielstrebig, umging die Mittelfeldverdichtung und nahm das Spiel direkt in Richtung Tor.',
          '{creator} zeigte mehr Variabilität im letzten Drittel — Flanken, Steckpässe und zweite Bälle sorgten für echte Gefahr.',
        ],
        pressure: [
          '{presser} leistete enorme Arbeit gegen den Ball und machte es dem Gegner schwer, den ersten Pass sauber zu spielen.',
          '{presser}s defensive Disziplin stach hervor — Mittelfeldspieler liefen schnell zurück und erstickten Gefahr, bevor sie den Strafraum erreichte.',
          'Die physische Intensität war hoch. {presser} unterband die Zulieferlinien mit unermüdlichem Pressing und Nachsetzen.',
          '{presser} war aggressiv im Wiedergewinnen des Balls — nicht immer mit Abschlüssen, aber durch Unterbinden von Kontern.',
        ],
        balanced: [
          'Beide Seiten agierten vorsichtig, hielten eine kompakte Ordnung und ließen das Spiel in Zweikämpfen und zweiten Bällen entscheiden.',
          'Das war kein offenes Spiel. Keine Seite gab ihre defensive Struktur auf und verließ sich auf wenige entscheidende Pässe für den Durchbruch.',
          'Beide Teams gingen vorsichtig mit Risiko um, hielten sich nach vorne zurück. Das Spiel wurde von einigen wenigen hochklassigen Momenten geprägt.',
          'Taktisch neutralisierten sich die Seiten gegenseitig: eine versuchte zu beschleunigen, die andere verstopfte die zentralen Räume.',
          'Mittelfeldduelle unterbrachen immer wieder den Spielfluss — beide Seiten priorisierten defensive Umschaltbewegungen.',
        ],
      },
      coach: {
        late: [
          'Die Geduld des Trainerstabs zahlte sich aus. {winner} überstürzte nichts in der zweiten Hälfte, wartete auf Ermüdungserscheinungen des Gegners und schlug dann zu.',
          '{winner}s Wechsel und Ordnung blieben synchron, was anhaltenden Druck in der Schlussphase ermöglichte — ein Zeichen guten Spielmanagements.',
          '{winner} behielt in der Pattsituation die Ordnung. Das späte Tor war eher natürliches Ergebnis anhaltenden Drucks als Verzweiflung.',
          '{winner}s Trainerteam entschied sich, in der Schlussphase weiter nach vorne zu drängen — eine Entscheidung, die den entscheidenden Moment brachte.',
        ],
        red: [
          'Nach der Roten Karte stellte {redTeam}s Trainerteam die Formation um und verließ sich auf einen kompakten Block und schnelle Entlastungsangriffe, um im Spiel zu bleiben.',
          '{opponent} versuchte, mit einem Mann mehr das Feld breit zu machen, aber {redTeam}s kompakte Antwort verhinderte, dass das Spiel entglitt.',
          'In Unterzahl war {redTeam}s Anpassungsfähigkeit gefragt. Sie reduzierten riskante Pässe durchs Mittelfeld und priorisierten defensive Stabilität.',
          '{opponent}s Trainerteam drängte nach der Roten auf schnellere Ballbewegungen, um den zahlenmäßigen Vorteil in Überzahl auf den Flügeln zu nutzen.',
        ],
        narrow: [
          '{winner}s Trainerteam traf eine pragmatische Entscheidung — nach der Führung jagten sie nicht weiteren Toren hinterher, sondern schützten den Vorsprung mit solider Positionierung.',
          '{winner} priorisierte nach dem Tor Kontrolle, minimierte unnötige Risiken und hielt das Spiel beherrschbar.',
          '{winner} gewann ohne Überschwang. Das Risikomanagement des Trainerteams saß perfekt, ließ {loser} wenig Chancen zum Zurückschlagen.',
          'Der Sieg spiegelte {winner}s realistischen Ansatz wider: zuerst die Defensive sichern, dann die Offensivspieler entscheiden lassen.',
        ],
        win: [
          '{winner} setzte den Spielplan effektiv um und behielt auch nach der Führung die offensive Struktur.',
          '{winner} positionierte sich intelligent in den Umschaltmomenten. Das Trainerteam verlangte offenbar sofortiges Pressing nach Ballverlust.',
          '{winner}s Sieg war nicht nur individuelle Qualität — die Ordnung und Absicherung bei zweiten Bällen untermauerten das Ergebnis.',
          '{winner} zeigte reifes Spielmanagement, wusste, wann Druck ausgeübt und wann der Ball gehalten werden musste.',
        ],
        draw: [
          'Kein Trainerteam ging im Unentschieden volles Risiko. Späte Wechsel und Positionierung tendierten zur Niederlagenvermeidung.',
          'Beide Seiten versuchten, über die Breite zu kommen, aber die Innenverteidigung wurde nie dauerhaft überwunden.',
          'Das Unentschieden spiegelte die Vorsicht beider Trainer wider: Angriffswille war da, aber keiner wollte sich vollständig nach vorne werfen.',
          'Beide Teams verstärkten in der Schlussphase den Mittelfeldschutz aus Sorge, dass ein Konter das Spiel entscheiden könnte.',
        ],
      },
      player: {
        goals: [
          '{player} war der herausragende Name, veränderte das Spiel mit mehreren Abschlüssen und erhielt eine {rating}-Bewertung.',
          '{player}s Torinstinkt entschied das Spiel — seine Läufe fanden immer wieder die schwer zu verteidigenden Räume.',
          '{team}s Angriff wurde von {player} vollendet, dessen ruhige Abschlüsse die gegnerische Abwehr ständig unter Druck hielten.',
          '{player} war der Unterschied, verwandelte Chancen in echten Druck auf der Anzeigetafel.',
        ],
        attack: [
          '{player} war in Schlüsselmomenten einflussreich. Über Tore und Vorlagen hinaus hielt sein Kombinationsspiel {team} in Bewegung.',
          '{player}s Beitrag ging über die Statistik hinaus — er tauchte immer dort auf, wo der Angriff einen Dreh- und Angelpunkt brauchte.',
          '{player} nutzte sein Zeitfenster in diesem Spiel, traf die entscheidenden Entscheidungen, die {team}s Angriff einen Fokus gaben.',
          '{player} war im letzten Drittel entscheidend — wusste, wann er passen und wann er schießen musste, eine verlässliche Anspielstation für {team}.',
          '{player}s Bewegung schuf Räume, und seine direkte Beteiligung veränderte den Spielverlauf.',
        ],
        saves: [
          '{player}s Arbeit im Tor war lebenswichtig. Mehrere Paraden hielten {team} im Spiel.',
          'Torhüter {player} verdient eine besondere Erwähnung, hielt eine Parade nach der anderen.',
          '{team} hielt unter Druck stand, dank {player}s Reflexen — seine Torhüterqualitäten waren ein Schlüsselfaktor.',
          '{player} hatte wenig Raum für Fehler, meisterte aber alles sauber und blieb auch bei Nahdistanz-Schüssen ruhig.',
        ],
        create: [
          '{player} war {team}s wichtigstes Bindeglied im letzten Drittel und schuf mit Torschussvorlagen Abschlussmöglichkeiten für Mitspieler.',
          '{player}s Spielübersicht prägte {team}s Angriffsmuster — er fand stets Passwege in engen Räumen.',
          '{team} brauchte jemanden, der den Ball in gefährliche Zonen brachte, und {player} füllte diese Rolle perfekt aus.',
          '{player} jagte nicht nur Toren hinterher — er nutzte Pässe, um Mitspieler in bessere Schussposition zu bringen.',
        ],
        defense: [
          '{player} arbeitete defensiv auf riesigem Raum, mit Zweikämpfen und Abfangen, die {team}s Mittelfeldabsicherung stärkten.',
          '{team} begrenzte des Gegners Vorankommen dank {player}s Rückwärtsbewegung und Antizipation.',
          '{player}s Wert lag im Spiel gegen den Ball, indem er immer wieder gegnerische Passzüge im Aufbau unterbrach.',
          '{player} verdient Anerkennung für seine Defensivarbeit und bewahrte {team} vor mehreren gefährlichen Situationen um den Strafraum.',
        ],
        shots: [
          '{player} verwandelte seine Chancen nicht in Tore, aber die ständigen Abschlüsse hielten die gegnerische Abwehr in Alarmbereitschaft.',
          'Ein großer Teil von {team}s Angriffsgefahr ging von {player} aus, der immer wieder mit Schüssen den Durchbruch suchte.',
          '{player}s Aggressivität war bemerkenswert — viele Schüsse zeigten, dass er im letzten Drittel immer wieder Räume fand.',
          '{player} war nah dran an einem Tor — seine Versuche zwangen den gegnerischen Torwart bereits in höchste Alarmbereitschaft.',
        ],
        general: [
          '{player} erhielt eine der besten Bewertungen, lieferte für {team} in beide Richtungen solide Leistungen.',
          '{player}s Zahlen erzählen nicht die ganze Geschichte — seine Beteiligung war entscheidend, um {team} im Rhythmus zu halten.',
          '{player}s Allround-Leistung war die anerkannteste und traf in mehreren Situationen die richtigen Entscheidungen.',
          '{player}s Wert lag in seiner Verlässlichkeit — selten vergab er Ballbesitz und war immer für Defensivarbeit verfügbar.',
        ],
      },
      impact: {
        finalWin: '{winner} gewann das Finale und hob den WM-Pokal in die Höhe. {loser}s Reise endete einen Schritt zu früh.',
        thirdPlace: '{winner} belegte den dritten Platz bei der WM, während {loser} Vierter wurde.',
        semiFinal: '{winner} zog mit diesem Sieg ins Finale ein und beendete {loser}s Hoffnungen auf den Pokal.',
        quarterFinal: '{winner} erreichte das Halbfinale, nur noch ein Sieg vom Finale entfernt.',
        knockoutWin: '{winner} zieht in die nächste K.o.-Runde ein, während {loser} ausscheidet.',
        placementBothDark: 'Beide Teams übertrafen ihre Vorrunden-Quoten deutlich — das Spiel um Platz 3 war selbst eine Außenseitergeschichte.',
        placementThirdDark: '{thirdName} schaffte es aufs Podium, obwohl das Team vor dem Turnier nicht unter den Top 20 der Quoten war — alle Erwartungen übertroffen.',
        placementFourthDark: '{fourthName} verlor dieses Spiel, aber das Erreichen des Halbfinals übertraf bereits die Erwartungen vor dem Turnier.',
        placementBothFavored: 'Beide Teams gehören vor dem Turnier zu den Top 20 nach Quoten, und das Erreichen der letzten Vier entsprach weitgehend den Erwartungen.',
        groupLead: '{teamName} hat {points} Punkte aus {played} Gruppenspielen, liegt auf Platz {rank} und ist in einer starken Position zur Qualifikation.',
        groupEliminated: '{teamName} hat nur {points} Punkte aus {played} Spielen, liegt auf Platz {rank} und kann sich nicht mehr qualifizieren.',
        groupUpdate: 'Nach diesem Spiel hat {teamName} {points} Punkte, aktuell Platz {rank} in Gruppe {group}.',
        groupQualifiers: 'Gruppe {groupId}: {names}',
        qualified: 'qualifiziert',
        eliminated: 'ausgeschieden',
        favoriteStatus: '{name} {status}',
        darkHorses: '{names} sind die bemerkenswertesten Außenseiter dieser Phase und übertreffen die Erwartungen in Punkten, Tordifferenz oder Schlüsselspielen.',
        noDarkHorses: 'Insgesamt behaupteten sich die Favoriten — die Gruppentabellen sahen keine größeren Umwälzungen.',
        unbeaten: '{names} bleiben ungeschlagen und zeigen beeindruckende Konstanz.',
        scorers: 'Individuell: {scorerLine}. {assisterLine}.{ratingLine}',
        scorerLead: '{name} führt die Torschützenliste mit {goals} Toren an',
        scorerDisperse: 'Das Rennen um die Torjägerkanone bleibt offen',
        assisterLead: '{name} führt die Vorlagenliste mit {assists} an',
        assisterDisperse: 'Die Vorlagenwertung ist weiterhin eng umkämpft',
        ratingHighlight: ' {name} hat einen Schnitt von {rating} — einer der herausragendsten Spieler der Gruppenphase.',
      },
      recap: {
        groupIntro: [
          'Die Gruppenphase ist abgeschlossen. 32 Teams haben sich qualifiziert, und die WM geht in die K.o.-Runde.',
          '72 Gruppenspiele sind gespielt. Die Qualifikanten, Überraschungen und individuellen Ranglisten haben sich herauskristallisiert.',
          'Gruppenphase beendet. Die Konstanz der Topteams, Außenseiter-Überraschungen und das Torjägerrennen prägten diese Phase.',
        ],
        knockoutIntro: 'Der {stage} ist abgeschlossen. {count} Teams sind noch im Rennen um die Meisterschaft.',
        knockoutWinners: '{names} buchten ihre Tickets für die nächste Runde.',
        knockoutTight: '{count} Spiele wurden durch ein einziges Tor entschieden oder gingen ins Elfmeterschießen — die K.o.-Spannung steigt.',
        knockoutClear: 'Die Ergebnisse in dieser Runde waren relativ eindeutig, die Sieger zeigten mehr Kontrolle.',
        knockoutBiggest: 'Das offenste Spiel der Runde war {match} mit insgesamt {goals} Toren.',
        knockoutUpset: 'Die Überraschung brachte {winner} mit einem Sieg über {loser} — das schlechter eingestufte Team lieferte die effizientere Leistung ab.',
        knockoutScorers: 'Individuell: {scorerLine}; {ratingLine}',
        knockoutScorerLead: '{name} führt weiterhin die Torschützenliste mit {goals} Toren an',
        knockoutScorerDisperse: 'Das Rennen um die Torjägerkanone ist noch völlig offen',
        knockoutRating: '{name} hält eine hohe Bewertung, einer der konstantesten Stars der K.o.-Runde.',
        knockoutRatingGeneric: 'Die Form der Schlüsselspieler beginnt, das Meisterschaftsrennen zu prägen.',
        groupLines: 'Qualifikanten nach Gruppe: {lines}. {favorites}',
        groupFavorites: 'Unter den Favoriten: {status}.',
        groupQualifierFormat: 'Gruppe {groupId}: {names}',
        groupMeta: '{count} qualifiziert · {scorerInfo}',
        scorerInfo: 'Torschütze {name}',
        scorerInfoUpdate: 'Statistiken aktualisiert',
        factQualified: '{count} qualifiziert',
        factDarkHorses: 'Außenseiter {names}',
        factStable: 'Favoriten stabil',
        factTopScorer: 'Torschützenkönig {name} {goals}T',
        factTopAssister: 'Vorlagenkönig {name} {assists}V',
        knockoutMeta: '{count} weiter · {tight} eng',
        factKnockoutTight: '{count} enge Spiele',
        factKnockoutClear: 'Klare Ergebnisse',
        factUpset: 'Überraschung {winner}',
        factOpen: '{goals} Tore',
      },
      preview: {
        intro: 'Die Paarungen des {stage} stehen fest. Die nächste Phase wird das Feld in {count} Spielen weiter verkleinern.',
        keyMatch: 'Schlüsselbegegnungen im Blick: {matches}.',
        noKeyMatch: 'Keine direkten Duelle zwischen Top-20-Quoten-Teams in dieser Phase — Favoriten müssen in vermeintlich günstigen Begegnungen aufpassen.',
        favorites: 'Basierend auf Form und Kaderstärke sind {names} favorisiert, weiterzukommen.',
        noFavorites: 'Der Abstand in dieser Runde ist gering — Form und Abschluss könnten mehr zählen als der Ruf.',
        tail: [
          'In der K.o.-Runde werden Spielmanagement, Verteidigung von Standardsituationen und Torhüterform entscheidend. Ein Fehler kann den gesamten Turnierbaum verändern.',
          'In dieser Phase geht es nicht nur um Angriffskraft. Auswechslungszeitpunkte, Risikomanagement und Vorbereitung auf Elfmeter werden die Ergebnisse beeinflussen.',
          'Favoriten müssen langsame Starts vermeiden, während Außenseiter das Spiel in ihre Komfortzone ziehen wollen. Die ersten 30 Minuten geben den Ton vor.',
        ],
        previewMeta: '{count} Spiele',
        factMatchup: '{count} Begegnungen',
        factFocus: 'Fokus {matchup}',
        factFavorite: 'Favorit {name}',
      },
      champion: {
        road: '{champion}s Weg zum Ruhm ist vollendet: {count} Spiele, {wins} Siege, {draws} Unentschieden, {goalsFor} Tore erzielt, {goalsAgainst} Gegentore.',
        groupPath: 'In der Gruppenphase sicherte sich {champion} frühzeitig die Qualifikation: {matches}.',
        knockoutPath: 'In der K.o.-Runde überwanden sie {opponents}.',
        signatureMatch: '{match} war die prägende Leistung ihrer Kampagne.',
        meta: '{wins}S{draws} · {goalsFor}-{goalsAgainst}',
        drawsText: '{draws}U',
        fact: 'Meister {champion}',
        factGoal: 'Tore {goalsFor}',
        factConcede: 'Gegentore {goalsAgainst}',
        factSignature: 'Paradespiel {match}',
        tail: [
          'Die prägende Eigenschaft dieses Meisters war Stabilität: Spiele kontrollieren in Führung liegend und neue Angriffswege finden bei Rückstand oder in der Sackgasse.',
          'Ihr Titel war nicht das Werk eines einzelnen Funkens — er kam von defensiver Solidität, konstanter Leistung der Schlüsselspieler und klarem Management.',
          'Was den Meister auszeichnete, war, sich nie von einem einzelnen schlechten Ergebnis brechen zu lassen und jede K.o.-Runde mit Gelassenheit zu meistern.',
        ],
      },
      awards: {
        intro: 'Mit dem Finale sind die individuellen Auszeichnungen der WM vergeben. {bestPlayer}',
        bestPlayer: '{name} verdiente sich die Auszeichnung als Bester Spieler mit konstant hohen Bewertungen und Schlüsselleistungen.',
        noBestPlayer: 'Das Rennen um den Besten Spieler war extrem eng, mehrere Stars zeigten Weltklasse-Leistungen.',
        topScorer: 'Der Goldene Schuh geht an {name} mit {goals} Toren — der zuverlässigste Vollstrecker des Turniers.',
        noTopScorer: 'Die Torschützenliste hatte keinen enteilten Spitzenreiter, aber die Effizienz der Stürmer entschied dennoch viele Spiele.',
        topAssister: 'Bei den Vorlagen führte {name} mit {assists} — seine Pässe veränderten direkt mehrere Spiele.',
        bestKeeper: 'Bester Torhüter wird {name} mit {saves} Paraden und durchschnittlich {conceded} Gegentoren pro Spiel.',
        noBestKeeper: 'Das Torhüter-Rennen konzentrierte sich auf einige wenige konstante Leistungsträger der K.o.-Runde.',
        scorerFallback: 'der Torschützenführer',
        keeperFallback: 'ein Top-Torwart-Kandidat',
        summary: '{names} bildeten die individuelle Erzählung dieses Turniers — einer kreierte, einer vollendete und einer hielt die Stellung.',
        noSummary: 'Individuelle Leistungen waren stark an Team-Systeme gebunden, geprägt von taktischen Rahmenbedingungen ebenso wie von persönlicher Qualität.',
      },
      review: {
        intro: 'Das Turnier ist vorbei. In {total} Spielen fielen {goals} Tore, ein Durchschnitt von {average} pro Spiel.',
        scoring: '{highScoring} Spiele hatten 4+ Tore, und in {btts} trafen beide Teams. {biggest}',
        biggest: 'Das torreichste Spiel war {match}.',
        upsetSep: 'besiegte',
        assisterFallback: 'mehrere Vorlagengeber',
        ratingFallback: 'Schlüsselspieler',
        upsets: 'Zu den Überraschungen zählen {upsets}.',
        noUpsets: 'Zum größten Teil bestätigten die Favoriten ihre Papierform, auch wenn die K.o.-Spiele oft von knappen Margen geprägt waren.',
        champion: 'Am Ende behielt {champion} am längsten die Nerven und wurde zur prägenden Geschichte des Turniers.',
        leaders: 'Individuell bildeten {scorer}s Abschlussstärke, {creators} Kreativität und {ratings} hohe Bewertungen das statistische Rückgrat des Turniers.',
        noLeaders: 'Dieses Turnier hatte sowohl Dominanz als auch Überraschungen — die tatsächlichen Geschichten waren reichhaltiger als jede einzelne Statistikzeile.',
        awardsMeta: 'Bester Spieler {name}',
        awardsMetaDefault: 'Auszeichnungsübersicht',
        factBestPlayer: 'Bester Spieler {name}',
        factTopScorer: 'Torschützenkönig {name} {goals}T',
        factBestKeeper: 'Bester TW {name}',
        factTopAssister: 'Vorlagenkönig {name} {assists}V',
        reviewMeta: '{count} Spiele · {goals} Tore',
        factTotalGoals: 'Gesamttore {goals}',
        factAvgGoals: 'Schnitt {average} pro Spiel',
        factHighScoring: '{count} mit 4+ Toren',
        factBothScored: '{count} beide getroffen',
      },
    },
  },
  helpers: {
    formText: { W: 'S', D: 'U', L: 'N' },
    goalState: {
      equalize: 'ausgleichen',
      lead: 'in Führung gehen',
      extend: 'Führung ausbauen',
      chase: 'Ergebnis verkürzen',
    },
    chanceState: {
      extend: 'Führung ausbauen',
      break: 'den Bann brechen',
      face: 'Ergebniskosmetik',
      close: 'Rückstand verkürzen',
    },
    tacticSummary: 'Mentalität {mentality} · Fokus {focus} · Pressing {pressing} · Linie {line}',
    teamMate: 'ein Mitspieler',
    attacker: 'ein Angreifer',
    defender: 'ein Verteidiger',
    advance: ' weiter',
    groupLeader: 'Gruppe {group}: {teamName} führt mit {points} Pkt.',
    unknownPlayer: 'Unbekannter Spieler',
    unsolved: 'N/V',
    minute: '{minute}\'{stoppage}',
    stoppageTime: '+{minute}',
  },
  rendering: {
    playerTotals: {
      headers: ['Spieler', 'Pos', 'E', 'Min', 'T', 'V', 'xG', 'Sch', 'Tz', 'Päs', 'Erf', 'TP', 'Zwe', 'Int', 'GK', 'RK', 'Par', 'Note'],
    },
    matchStats: {
      shotsOnTarget: 'Schüsse aufs Tor',
      passes: 'Pässe',
      passSuccess: 'Pass %',
      keyPasses: 'Torschussvorlagen',
      corners: 'Ecken',
      offsides: 'Abseits',
      fouls: 'Fouls',
      yellowCards: 'Gelbe Karten',
      redCards: 'Rote Karten',
      saves: 'Paraden',
      tackles: 'Zweikämpfe',
      interceptions: 'Abfangen',
    },
    modal: {
      best: 'Bester',
      record: 'Bilanz',
      stage: 'Phase',
      bestPlayer: 'Bester Spieler',
      signature: 'Paradespiel',
    },
    bracket: {
      pending: 'Ausstehend',
    },
  },
  mobile: {
    landing: { intro: 'WM-2026-Simulator', description: 'Vom Eröffnungsspiel bis zur Finalnacht: Tippe auf Weiter und verfolge die gesamte WM-2026-Simulation.', welcome: 'Willkommen in deiner eigenen WM-Zeit. Tippe dich durch eine schnelle Simulation und sieh, wer den Pokal holt. Am PC gibt es zusätzlich den Trainermodus.', hiddenStart: 'Mit versteckten Teams simulieren', start: 'Simulation starten', startTitle: 'Simulation sofort starten', startSubtitle: 'Echte Teams, echte Gruppen: Erlebe alle Spiele aus Zuschauersicht in weniger als zehn Minuten.', hiddenCheckbox: 'Italien, Polen, Indonesien, China und die VAE an der WM teilnehmen lassen' },
    topbar: { settings: 'Einstellungen' },
    tabs: { navigation: 'Mobile Navigation', news: 'News', fixtures: 'Spiele', standings: 'Tabelle', knockout: 'K.-o.-Runde', data: 'Daten' },
    action: { continue: 'Weiter', readNews: 'News lesen', simulateNext: 'Spieltag simulieren', restart: 'Neu starten', completed: 'Beendet' },
    settings: { title: 'Einstellungen', language: 'Sprache', restart: 'Neu starten', restartConfirm: 'Neu starten und die aktuelle mobile Simulation löschen?', close: 'Einstellungen schließen' },
    news: { previous: 'Zurück', next: 'Weiter', pcMore: 'Nutze die PC-Version für mehr Überraschungen und Funktionen.', empty: 'Noch keine News.' },
    fixtures: { previousDay: 'Voriger Spieltag', nextDay: 'Nächster Spieltag', noMatches: 'Keine Spiele an diesem Spieltag.' },
    standings: { groupStandings: 'Gruppentabellen', knockout: 'K.-o.-Runde', roundOf32: 'Runde der 32', roundOf16: 'Achtelfinale', quarterFinal: 'Viertelfinale', semiFinal: 'Halbfinale', thirdPlace: 'Platz drei', final: 'Finale' },
    data: { goals: 'Tore', assists: 'Assists', pcMore: 'Nutze die PC-Version für mehr Spieler- und Teamdaten.', empty: 'Noch keine Daten.' },
    team: { squad: 'Kader', fixtures: 'Spiele', tactic: 'Taktik', close: 'Teamansicht schließen' },
  },
    teamNames: {

    mexico: 'Mexiko', south_africa: 'Südafrika', south_korea: 'Südkorea',
    czechia: 'Tschechien', canada: 'Kanada', bosnia_herzegovina: 'Bosnien-Herzegowina',
    switzerland: 'Schweiz', qatar: 'Katar', brazil: 'Brasilien', morocco: 'Marokko',
    scotland: 'Schottland', haiti: 'Haiti', united_states: 'USA',
    australia: 'Australien', paraguay: 'Paraguay', turkiye: 'Türkei',
    germany: 'Deutschland', curacao: 'Curaçao', ivory_coast: 'Elfenbeinküste',
    ecuador: 'Ecuador', netherlands: 'Niederlande', japan: 'Japan',
    tunisia: 'Tunesien', sweden: 'Schweden', belgium: 'Belgien', iran: 'Iran',
    egypt: 'Ägypten', new_zealand: 'Neuseeland', spain: 'Spanien',
    uruguay: 'Uruguay', saudi_arabia: 'Saudi-Arabien', cape_verde: 'Kap Verde',
    france: 'Frankreich', senegal: 'Senegal', norway: 'Norwegen', iraq: 'Irak',
    argentina: 'Argentinien', austria: 'Österreich', algeria: 'Algerien',
    jordan: 'Jordanien', portugal: 'Portugal', colombia: 'Kolumbien',
    uzbekistan: 'Usbekistan', dr_congo: 'DR Kongo', england: 'England',
    croatia: 'Kroatien', panama: 'Panama', ghana: 'Ghana',
    italy: 'Italien',
    tbd: 'N.N.',
    china: 'China',

    indonesia: "Indonesien",
    united_arab_emirates: "VAE",
    poland: "Polen",

  },
};
